import { render, staticRenderFns } from "./SampleDetails.vue?vue&type=template&id=2ffa57ef&scoped=true"
import script from "./SampleDetails.vue?vue&type=script&lang=ts"
export * from "./SampleDetails.vue?vue&type=script&lang=ts"
import style0 from "./SampleDetails.vue?vue&type=style&index=0&id=2ffa57ef&prod&lang=scss&scoped=true"
import style1 from "./SampleDetails.vue?vue&type=style&index=1&id=2ffa57ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa57ef",
  null
  
)

export default component.exports